import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { useState } from 'react';

import { Glyph } from '../../common/Glyph';
import { CapabilitySelect } from '../CapabilitySelect';
import * as Containers from '../Containers';

import { useCapabilityValue } from '../../../store/devices/useCapabilityValue';
import { useDevice } from '../../../store/devices/useDevices.ts';

import { su } from '../../../theme/functions/su';
import { theme } from '../../../theme/theme';

import { getTernaryImage } from './getTernaryImage';

export function Ternary(props) {
  const { device } = useDevice({ deviceId: props.deviceId });

  const [selectedCapabilityId, setSelectedCapabilityId] = useState(() => {
    return props.component.capabilities[0];
  });

  const [value, setValue, capabilityObj] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: selectedCapabilityId,
  });

  function handleClick({ nextValue }) {
    setValue(nextValue).catch(() => {});
  }

  if (capabilityObj == null) {
    return null;
  }

  return (
    <Containers.Control>
      <Containers.Select>
        {props.component.capabilities.length > 1 && (
          <CapabilitySelect
            selectedCapabilityId={selectedCapabilityId}
            componentCapabilities={props.component.capabilities}
            capabilitiesObj={device?.capabilitiesObj}
            onSelectionChange={setSelectedCapabilityId}
          />
        )}
      </Containers.Select>
      <Containers.Action>
        {capabilityObj.values?.map((ternaryValue) => {
          return (
            <ButtonBase
              key={ternaryValue.id}
              initial={{
                backgroundColor:
                  value === ternaryValue.id ? theme.color.white_o_100 : theme.color.black_o_50,
              }}
              animate={{
                backgroundColor:
                  value === ternaryValue.id ? theme.color.white_o_100 : theme.color.black_o_50,
              }}
              onClick={() => {
                handleClick({
                  nextValue: ternaryValue.id,
                });
              }}
            >
              <motion.span
                style={{ display: 'flex' }}
                initial={{
                  color:
                    value === ternaryValue.id ? theme.color.white_o_100 : theme.color.black_o_50,
                }}
                animate={{
                  color: value === ternaryValue.id ? theme.color.green : theme.color.white_o_100,
                }}
              >
                <Glyph size="42px" color="currentColor" source={getTernaryImage(ternaryValue.id)} />
              </motion.span>
            </ButtonBase>
          );
        })}
      </Containers.Action>
    </Containers.Control>
  );
}

const ButtonBase = styled(motion.button)`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border: 0;
  border-radius: 50%;
  outline: none;
  cursor: pointer;

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  &:not(:last-child) {
    margin-bottom: ${su(6)};
  }
`;
